<template>
  <v-app id="app">
    <v-main>
      <SplashScreen v-if="loading" />

      <router-view v-else />
    </v-main>

    <AlertBar ref="alertBar" />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import { loadSession } from "@/services/auth";
import SplashScreen from "@/components/splashScreen/SplashScreen";
import AlertBar from "@/components/alertBar/AlertBar";

export default {
  name: "App",

  components: {
    SplashScreen,
    AlertBar,
  },

  data() {
    return {
      loading: true,
    };
  },

  created() {
    this.initTheme();
    this.handleSession();
  },

  beforeMount() {
    this.$root.$on("alert", this.handleAlert);
    this.$root.$on("sign-out", this.signOut);
    this.$root.$on("load-session", this.handleSession);
  },

  beforeDestroy() {
    this.$root.$off("alert", this.handleAlert);
    this.$root.$off("sign-out", this.signOut);
    this.$root.$on("load-session", this.handleSession);
  },

  methods: {
    ...mapActions(["setUser", "setSignOut"]),

    async handleSession() {
      const token = this.$store.getters.accessToken;

      if (token) {
        try {
          const { data } = await loadSession();
          this.setUser(data);
        } catch {
          this.signOut();
        }
      }

      this.loading = false;
    },

    async signOut() {
      try {
        this.loading = true;
        await this.setSignOut();

        if (this.$route.name !== "SignIn")
          this.$router.push({ name: "SignIn" });
      } catch (error) {
        this.handleAlert(error?.message, "error");
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    initTheme() {
      Object.entries(this.$settings?.colorPalette).forEach(([key, value]) => {
        if (
          this.$vuetify.theme.themes.dark &&
          this.$vuetify.theme.themes.dark[key] !== undefined
        )
          this.$vuetify.theme.themes.dark[key] = value;

        if (
          this.$vuetify.theme.themes.white &&
          this.$vuetify.theme.themes.white[key] !== undefined
        )
          this.$vuetify.theme.themes.white[key] = value;
      });
    },

    handleAlert(event) {
      this.$refs.alertBar.handleAlert(event);
    },
  },
};
</script>

<style lang="scss">
html {
  background: $neutral;
}

#app {
  background: $neutral;
}
</style>
